import { publicApiClient } from '@/services/public/publicApiClient'

/** Public endpoint (no auth) — server records IP from the request. */
export async function recordVisit(path: string, referer?: string | null) {
  await publicApiClient.post('/api/v1/analytics/visit', { path, referer: referer ?? undefined })
}
